import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseProvider } from './base-provider';
import { HttpClient } from '@angular/common/http';
import { Globals } from '../providers/globals';

declare var Card: any;
declare var $;
declare var Payment: any;

@Injectable()
export class PaymentMethodAgilpayService extends BaseProvider {
	constructor(
		public http: HttpClient,
		public globals: Globals
	){
		super();

		this.baseUrl = "userPaymentMethod";
	}

	create(params, businessId){
		return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl + "/business/" + businessId;
			
			this.http.post(
				this.url,
				params
			)
			.subscribe(
          		(res:any) => {
					resolve(res.Data);
				},
				err => {reject(err)}
			);
		});      
	}		
}